import React from 'react';
import { Icon } from './Icon.js';
export const IconSquareLayoutGrid3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11.5 5.5V8.75C11.5 10.2688 10.2688 11.5 8.75 11.5H6.75V5.5H11.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M8.75 0.5C10.2688 0.5 11.5 1.73122 11.5 3.25V4H6.75V0.5H8.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M5.25 6.5H0.5V3.25C0.5 1.73122 1.73122 0.5 3.25 0.5H5.25V6.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M5.25 11.5H3.25C1.73122 11.5 0.5 10.2688 0.5 8.75V8H5.25V11.5Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconSquareLayoutGrid3Fill12.js.map